const HamburgerIcon = () => {
  return (
    <svg width="24" height="18" viewBox="0 0 24 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M1.45898 2.92934H22.5414C23.3458 2.92934 24 2.27516 24 1.4707C24 0.666244 23.3458 0.0117188 22.5414 0.0117188H1.45898C0.654525 0.0117188 0 0.666244 0 1.4707C0 2.27516 0.654525 2.92934 1.45898 2.92934Z"
        fill="#B7B7B7"
      />
      <path
        d="M22.5414 7.54102H1.45898C0.654525 7.54102 0 8.19554 0 9C0 9.80446 0.654525 10.4586 1.45898 10.4586H22.5414C23.3458 10.4586 24 9.80446 24 9C24 8.19554 23.3458 7.54102 22.5414 7.54102Z"
        fill="#B7B7B7"
      />
      <path
        d="M22.5414 15.0703H1.45898C0.654525 15.0703 0 15.7252 0 16.5296C0 17.3341 0.654525 17.9883 1.45898 17.9883H22.5414C23.3458 17.9883 24 17.3341 24 16.5296C24 15.7252 23.3458 15.0703 22.5414 15.0703Z"
        fill="#B7B7B7"
      />
    </svg>
  );
};

export default HamburgerIcon;
